import React, {useState} from 'react'
import { useEthers } from '@usedapp/core';
import './MetamaskContainer.css'
import mmlogo from '../assets/metamask_logo.png'

const MetamaskContainer = (props) => {

    return (
        !props.account ?
        <div className="mmcontainer">
            <div className="heading">Check VIP Status</div>
            <div className={props.correctChain ? 'metamask-button' : 'metamask-button disabled'} id="metamaskBtn" onClick={() => props.activateBrowserWallet()}>
                <div className="metamask-logo-holder">
                    <img src={mmlogo} alt="Metamask Logo" className="mmlogo"></img>
                </div>
                <div className="metamask-title">Connect to Metamask</div>
            </div>
        </div>
        : <></>
    )
}

export default MetamaskContainer